import React from 'react';

import { useAnimateInRef } from '../../../utils/hooks';
import ForecastTemperature from './ForecastTemperature';

import * as styles from './Forecast.module.scss';

import wiDaySunnyIcon from '../svg/wi-day-sunny.svg';
import wiDayCloudyIcon from '../svg/wi-day-cloudy.svg';
import wiCloudIcon from '../svg/wi-cloud.svg';
import wiCloudyIcon from '../svg/wi-cloudy.svg';
import wiShowersIcon from '../svg/wi-showers.svg';
import wiRainIcon from '../svg/wi-rain.svg';
import wiDayLightningIcon from '../svg/wi-day-lightning.svg';
import wiSnowIcon from '../svg/wi-snow.svg';
import wiFogIcon from '../svg/wi-fog.svg';

export type WeatherStateId =
  | 'sunny'
  | 'few-clouds'
  | 'cloudy'
  | 'overcast'
  | 'showers'
  | 'rain'
  | 'thunderstorm'
  | 'snow'
  | 'fog';

const iconByWeatherState = {
  sunny: wiDaySunnyIcon,
  'few-clouds': wiDayCloudyIcon,
  cloudy: wiCloudIcon,
  overcast: wiCloudyIcon,
  showers: wiShowersIcon,
  rain: wiRainIcon,
  thunderstorm: wiDayLightningIcon,
  snow: wiSnowIcon,
  fog: wiFogIcon,
} as const;

interface ForecastProps {
  id: string;
  icon: WeatherStateId;
  title: string;
  animationDelay: number;
  minTemp: number;
  maxTemp: number;
}

const Forecast = ({
  title,
  icon,
  animationDelay,
  minTemp,
  maxTemp,
}: ForecastProps): React.ReactElement => {
  return (
    <div ref={useAnimateInRef(styles.animateIn, animationDelay + 100)} className={styles.forecast}>
      <span ref={useAnimateInRef(styles.animateIn, animationDelay + 200)} className={styles.title}>
        {title}
      </span>
      <img
        ref={useAnimateInRef(styles.animateIn, animationDelay + 250)}
        className={styles.icon}
        alt="icon"
        src={iconByWeatherState[icon]}
      />

      <div>
        <ForecastTemperature temperature={maxTemp} animationDelay={animationDelay + 350} />
        <ForecastTemperature temperature={minTemp} animationDelay={animationDelay + 350} />
      </div>
    </div>
  );
};

export default Forecast;
